<template>
  <div id="template-checkout">
    <transition name="slide">
      <BookingPage
        v-if="isCheckout()"
      />
      <ConfirmationPage
        v-if="isConfirmation()"
      />
    </transition>
  </div>
</template>

<script>
import BookingPage from './BookingPage.vue';
import ConfirmationPage from './ConfirmationPage.vue';

export default {
  props: [
    'step',
    'customer_service_phone',
    'breakdown',
    'dates',
    'listing',
    'reservation',
    'optional_fees',
    'fee_groups',
    'addons_title',
    'addons_description',
    'create_account_text',
    'current_user',
    'terms_text',
    'policies_text',
    'newsletter_text',
    'max_guests',
    'host'
  ],
  components: {
    BookingPage,
    ConfirmationPage
  },
  beforeCreate() {
    this.$store.commit('initializeErrors')
    this.$store.commit('checkoutSubmitting', false)
  },
  created() {
    let props = Object.assign({}, this._props)
    this.$store.commit('setAppData', props)
  },
  methods: {
    isCheckout() {
      return this.$store.state.app_data.step === 'checkout'
    },
    isConfirmation() {
      return this.$store.state.app_data.step === 'confirmation'
    }
  }
}
</script>

<style>
.slide-enter-active,
.slide-leave-active {
  transition: transform .6s ease;
}
.slide-enter {
  transform: translateX(100%);
}
.slide-leave-to {
  transform: translateX(-100%);
}
</style>
